const TabStatusEnum = {
  OPEN: 'open',
  CLOSE: 'close'
};

module.exports = TabStatusEnum;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/enums/TabStatusEnum.js
 **/